import React, { Component } from "react";
// import { settingsStart, getSettingsSuccess, settingsFailure } from '../../../../../../../src/redux/actions/settings'

// Ajax Methods
import ajaxMethods from "../../../../../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../../../../../api/ajax-endpoints";

// Validators
// import {exists, isEmail, numbersOnly, isPassword, valuesMatch} from '../../../../../../helpers/validators';

// Forms
// import  LoanForm from './Forms/LoanForm';
// import  InvestmentForm from './Forms/InvestmentForm';
import SystemForm from "./Forms/SystemForm";
import RevenueForm from "./Forms/RevenueForm";
import { productStatus } from "../../../../../../models/product-data-model";

import DefaultProductSettings from "./Forms/DefaultProductSettings";
import { appInsights } from "../../../../../../config/appInsights";

// Style
import "./GlobalSettings.css";

export default class GlobalSettings extends Component {
  //State
  state = {
    revenueEdit: false,
    systemEdit: false,
    loading: false,
    revenueForm: {
      aggregator_share: 0,
      funder_share: 0,
      platform_share: 0,
      default_bvn_provider: 1,
      default_non_nigerian_id_provider: 0,
      first_repayment_NotificationDays: 0,
      maximum_number_of_rollover: 0,
      maximum_rollover_percentage: 0,
      principal_repayment_percentage: 0,
      second_repayment_NotificationDays: 0,
      emails: "",
      loan_notification_recipients: "",
      usd_liquidation_channel_account_id: "",
      usd_liquidation_channel_id: "",
      funder_usd_wallet_product_id: "",
      funder_lcy_wallet_product_id: "",
    },
    revenueFormCopy: {
      aggregator_share: 0,
      funder_share: 0,
      platform_share: 0,
      default_bvn_provider: 1,
      default_non_nigerian_id_provider: 0,
      first_repayment_NotificationDays: 0,
      maximum_number_of_rollover: 0,
      maximum_rollover_percentage: 0,
      principal_repayment_percentage: 0,
      second_repayment_NotificationDays: 0,
      emails: "",
      loan_notification_recipients: "",
      usd_liquidation_channel_account_id: "",
      usd_liquidation_channel_id: "",
      funder_usd_wallet_product_id: "",
      funder_lcy_wallet_product_id: "",
    },
    systemForm: {
      categoryList: [],
      category_name: "",
      category_code: "",
    },
    systemFormCopy: {
      categoryList: [],
      category_name: "",
      category_code: "",
    },
    disbursementChannelOptions: [],
    selectedDisbursementId: "",
    bankId: "",
    accountNumber: "",
    bankOptionsList: [],
    disburseEdit: false,
    bankName: "",
    allproductStatusChoices: [],
    statusOption: "",
    ProductCatergorySectors: [],
    productCategoryId: "",
  };

  // Life Cycle Hooks
  componentDidMount() {
    this.populateCategories();
    this.getRevenueSettings();
    this.getProductStatusChoices();
    this.getProductSector();
  }

  // Component Methods
  getRevenueSettings = () => {
    ajaxMethods
      .get(ajaxEndpoints.GLOBAL_REVENUE_SETTINGS)
      .then((response) => {
        if (response) {
          this.setState({
            revenueForm: response.data,
            revenueFormCopy: response.data,
          });
        } else {
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "GlobalSettings.js",
          },
        });
      });
  };

  editModeHandler = (target) => {
    this.setState({ bankId: "", accountNumber: "" });
    let selectedForm = target.dataset["form"];
    if (this.state.selectedDisbursementId) {
      this.getDisbursementChannelDetails();
    }

    this.setState({
      [`${selectedForm}Edit`]: true,
    });
  };

  inputChangeHandler = (target) => {
    const { name, value, dataset, type } = target;
    let selectedForm = dataset["form"];
    if (name === "default_bvn_provider") {
      this.setState({
        [`revenueFormCopy`]: {
          ...this.state[`revenueFormCopy`],
          [name]: parseInt(value),
        },
      });
    }
    if (name === "funder_lcy_wallet_product_id") {
      this.setState({
        [`revenueFormCopy`]: {
          ...this.state[`revenueFormCopy`],
          [name]: parseInt(value),
        },
      });
    }
    if (name === "funder_usd_wallet_product_id") {
      this.setState({
        [`revenueFormCopy`]: {
          ...this.state[`revenueFormCopy`],
          [name]: parseInt(value),
        },
      });
    } else if (
      type === "radio" &&
      name === "default_non_nigerian_id_provider"
    ) {
      this.setState({
        [`${selectedForm}FormCopy`]: {
          ...this.state[`${selectedForm}FormCopy`],
          [name]: parseInt(value),
        },
      });
    } else {
      this.setState({
        [`${selectedForm}FormCopy`]: {
          ...this.state[`${selectedForm}FormCopy`],
          [name]: value,
        },
      });
    }
  };

  cancelUpdateHandler = (target) => {
    let selectedForm = target.dataset["form"];

    this.setState({
      [`${selectedForm}Edit`]: false,
      [`${selectedForm}FormCopy`]: this.state[`${selectedForm}Form`],
    });
  };

  onSettingsUpdate = (target) => {
    let selectedForm = target.dataset["form"];
    const { ...data } = this.state[`${selectedForm}FormCopy`];
    const newData = {
      ...data,
      first_repayment_NotificationDays: Number(
        data.first_repayment_NotificationDays
      ),
      principal_repayment_percentage: Number(
        data.principal_repayment_percentage
      ),
      maximum_number_of_rollover: Number(data.maximum_number_of_rollover),
      maximum_rollover_percentage: Number(data.maximum_rollover_percentage),
      second_repayment_NotificationDays: Number(
        data.second_repayment_NotificationDays
      ),
      usd_liquidation_channel_account_id: Number(
        data.usd_liquidation_channel_account_id
      ),
      usd_liquidation_channel_id: Number(data.usd_liquidation_channel_id),
    };
    if (selectedForm === "revenue") {
      ajaxMethods
        .post(ajaxEndpoints.GLOBAL_REVENUE_SETTINGS_UPDATE, newData)
        .then((response) => {
          if (response.status === 200) {
            return this.props.onSetToast("success", response?.data?.message);
          } else if (response.status === 400) {
            return this.props.onSetToast(
              "error",
              `There was an issue updating revenue settings: ${response.data.message}`
            );
          } else {
            return this.props.onSetToast(
              "warning",
              "There was an issue updating revenue settings"
            );
          }
        })
        .catch((error) => {
          appInsights.trackException({
            exception: error,
            properties: {
              fileName: "GlobalSettings.js",
            },
          });
          return this.props.onSetToast(
            "error",
            "There was an issue updating revenue settings"
          );
        });

      this.setState({
        [`${selectedForm}Edit`]: false,
      });
    }
  };

  populateCategories = () => {
    ajaxMethods
      .get(ajaxEndpoints.CATEGORY_LIST)
      .then((response) => {
        let categoryList = [];

        if (response.data.length > 0) {
          categoryList = [...response.data];
        } else {
          categoryList = [
            {
              category_id: 0,
              category_name: "No Categories Yet",
              category_slug: "No Categories Yet",
            },
          ];
        }

        this.setState({
          systemEdit: false,
          systemForm: {
            ...this.state.systemForm,
            categoryList: [...categoryList],
          },
          systemFormCopy: {
            ...this.state.systemFormCopy,
            categoryList: [...categoryList],
          },
        });
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "GlobalSettings.js",
          },
        });
      });
  };

  addCategoryHandler = () => {
    const category = {
      name: this.state.systemFormCopy.category_name,
      code: this.state.systemFormCopy.category_code,
    };

    ajaxMethods
      .post(ajaxEndpoints.CATEGORY_ADD, category)
      .then((response) => {
        let message = "";
        if (response.status === 201 || response.status === 200) {
          message = response.data.message;
          this.props.onSetToast("success", message);
          this.populateCategories();
        } else if (response.status === 400) {
          message = response.data.message;
          this.props.onSetToast("error", message);
        } else {
          this.props.onSetToast(
            "warning",
            "Unable to connect to Advancly services"
          );
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "GlobalSettings.js",
          },
        });
        this.props.onSetToast(
          "warning",
          "Unable to connect to Advancly services"
        );
      });
  };

  // fetch Disbursement channel details
  getDisbursementChannelDetails = () => {
    ajaxMethods
      .get(
        ajaxEndpoints.GET_DISBURSEMENT_CHANNEL_LIST +
          `?disbursement_channel_id=${this.state.selectedDisbursementId}`
      )
      .then((response) => {
        if (response.status_code === 200 || response.status_code === 201) {
          let res = response.data[0];
          this.setState({
            bankId: res.bank_id,
            accountNumber: res.account_number,
            bankName: res.bank_name,
          });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "GlobalSettings.js",
          },
        });
      });
  };

  //   //get bank list
  //   getBankList = () => {
  //     ajaxMethods
  //       .get(ajaxEndpoints.GET_BANK_LIST)
  //       .then((response) => {
  //         if (response.status_code === 200 || response.status_code === 201) {
  //           let bankList = response.data
  //           const bankOptionsList = bankList.map((data, index) => {
  //             return <option value={data.id} key={index}>{data.name}</option>
  //           })
  //           this.setState({ bankOptionsList: bankOptionsList });

  //         }
  //       })
  //       .catch(() => {

  //       })

  //   }

  //   onDisbursement=()=>{
  //       const{selectedDisbursementId,
  //         bankId,
  //         accountNumber}=this.state
  //     const disburse = {
  //         channel_id:selectedDisbursementId,
  //         bank_id:bankId,
  //         account_number:accountNumber
  //     };

  //     ajaxMethods.post(ajaxEndpoints.ADD_DISBURSEMENT_ACCOUNT, disburse)
  //         .then(response => {
  //             let message = '';
  //             if (response.status_code === 200||response.status===200||response.data.status===200) {
  //
  //                 message = response.data.message;
  //                 this.props.onSetToast('success', message);
  //                 this.setState({disburseEdit:false})
  //             } else if (response.status === 400) {
  //                 message = response.data.message;
  //                 this.props.onSetToast('error', message);
  //             } else {
  //                 this.props.onSetToast('warning', 'Please check your network, and try again');
  //             }

  //         })
  //         .catch(error => {
  //             //
  //             this.props.onSetToast('warning', 'Please check your Network, and try again');
  //         });
  //   }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleOptionSelect = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  //get product Status choices
  getProductStatusChoices = () => {
    const allproductStatusChoices = productStatus.map((ecosystem, index) => {
      const { productStatusName, status } = ecosystem;
      return (
        <option key={index} id={status} value={status}>
          {productStatusName}
        </option>
      );
    });
    this.setState({
      allproductStatusChoices: allproductStatusChoices,
    });
  };

  // fetch product category list
  getProductSector = () => {
    ajaxMethods
      .get(ajaxEndpoints.GET_PRODUCT_CATEGORY_SECTORS)
      .then((response) => {
        if (response.status_code === 200) {
          this.setState({ ProductCatergorySectors: response.data });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "GlobalSettings.js",
          },
        });
      });
  };
  // handle create default products
  handleCreateDefaultProduct = () => {
    const { statusOption, productCategoryId } = this.state;
    const data = {
      status: statusOption,
      product_category_id: productCategoryId,
    };
    ajaxMethods
      .post(ajaxEndpoints.CREATE_DEFAULT_PRODUCT, data)
      .then((response) => {
        if (response.status === 200) {
          return this.props.onSetToast(
            "success",
            `You have succefully updated your revenue settings`
          );
        } else if (response.status === 400) {
          return this.props.onSetToast(
            "error",
            `There was an issue updating revenue settings: ${response.data.message}`
          );
        } else {
          return this.props.onSetToast(
            "warning",
            "There was an issue updating revenue settings"
          );
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "GlobalSettings.js",
          },
        });
        return this.props.onSetToast(
          "error",
          "There was an issue updating revenue settings"
        );
      });
  };

  render() {
    const { systemFormCopy, revenueFormCopy } = this.state;

    return (
      <div className="GlobalSettings mt-30">
        <div className="row col-12">
          {/* <div className="col-lg-4 col-md-6 col-sm-12">
                            <LoanForm 
                                inputs={ loanFormCopy } 
                                onEditMode={ this.editModeHandler }
                                onCancelUpdate={ this.cancelUpdateHandler }
                                onInputChange = { this.inputChangeHandler }
                                onLoanUpdate = {this.onSettingsUpdate} />
                        </div> */}

          <div className="col-lg-4 col-md-6 col-sm-12">
            {/* <InvestmentForm 
                                inputs={ investmentFormCopy }
                                onEditMode={ this.editModeHandler }
                                onCancelUpdate={ this.cancelUpdateHandler }
                                onInputChange = { this.inputChangeHandler }
                                onInvestmentUpdate = {this.onSettingsUpdate} /> */}

            <RevenueForm
              inputs={revenueFormCopy}
              onEditMode={this.editModeHandler}
              onCancelUpdate={this.cancelUpdateHandler}
              onInputChange={this.inputChangeHandler}
              revenueEdit={this.state.revenueEdit}
              onRevenueUpdate={this.onSettingsUpdate}
            />
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <SystemForm
              inputs={systemFormCopy}
              onEditMode={this.editModeHandler}
              onCancelUpdate={this.cancelUpdateHandler}
              onInputChange={this.inputChangeHandler}
              onAddCategory={this.addCategoryHandler}
              systemEdit={this.state.systemEdit}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <DefaultProductSettings
              handleOptionSelect={this.handleOptionSelect}
              handleCreateDefaultProduct={this.handleCreateDefaultProduct}
              allproductStatusChoices={this.state.allproductStatusChoices}
              ProductCatergorySectors={this.state.ProductCatergorySectors}
              productCategoryId={this.state.productCategoryId}
              statusOption={this.state.statusOption}
            />
          </div>
        </div>
      </div>
    );
  }
}
